import { IconButton, Stack } from "@mui/material";
import { PencilIcon, TrashIcon } from "@phosphor-icons/react";
import { memo } from "react";

const StructureTypeActions = memo(({ onEdit, onDelete }) => (
  <Stack direction="row" spacing={1}>
    <IconButton onClick={onEdit} size="small">
      <PencilIcon />
    </IconButton>
    <IconButton onClick={onDelete} size="small" color="error">
      <TrashIcon />
    </IconButton>
  </Stack>
));

StructureTypeActions.displayName = "StructureTypeActions";

export default StructureTypeActions;
